import React, { useEffect, useState } from 'react';
import { Box, styled, Typography } from '@mui/material';
import negativeIcon from '../assets/negative.svg';
import neutralIcon from '../assets/neutral.svg';
import positiveIcon from '../assets/positive.svg';
import { StyledRowBox } from '../theme/StyledElements';
import { ReviewModel } from '../models/Review';

const StyledEmojiBox = styled(StyledRowBox)(() => ({
    marginTop: '10px',
    textAlign: 'center',
    justifyContent: 'space-between'
}));

const StyledEmojis = styled('img')(() => ({
    marginBottom: '10px',
    textAlign: 'center',
    height: '40px',
    width: '40px'
}));

interface EmojiCardProps {
    review: ReviewModel;
}

export function EmojiCard({ review }: EmojiCardProps): React.ReactElement {
    const [reviewData, setReviewData] = useState<ReviewModel>(review);

    useEffect(() => {
        if (review) {
            setReviewData(review);
        }
    }, [review]);
    return (
        <StyledEmojiBox>
            <Box>
                <StyledEmojis src={negativeIcon} />
                <Typography variant="subtitle2" color="#DE2121">
                    {reviewData?.dislikedPercentage ?? 0}%
                </Typography>
            </Box>
            <Box>
                <StyledEmojis src={neutralIcon} />
                <Typography variant="subtitle2" color="#636762">
                    {reviewData?.neutralPercentage ?? 0}%
                </Typography>
            </Box>
            <Box>
                <StyledEmojis src={positiveIcon} />
                <Typography variant="subtitle2" color="#266ED1">
                    {reviewData?.likedPercentage ?? 100}%
                </Typography>
            </Box>
        </StyledEmojiBox>
    );
}
